// context/AuthContext.js
import { createContext, useContext, useState, useEffect } from "react";
import Cookies from "js-cookie";
import { toast } from 'react-toastify';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null); 
  const [loading, setLoading] = useState(true); 

  useEffect(() => {
    const token = Cookies.get("token");
    const userInfo = Cookies.get("user");
    // console.log("🍪 Cookie on reload:", { token, userInfo });
   if (token && userInfo){
    // if (token) {
      setIsAuthenticated(true);
      //below line was commented
      setUser(JSON.parse(userInfo));
    }
    setLoading(false); 
  }, []);

  const login = (token, userData) => {

   
    Cookies.set("token", token, { expires: 7, path: "/" });
    Cookies.set("user", JSON.stringify(userData), { expires: 7, path: "/" });
  
    setIsAuthenticated(true);
    setUser(userData);
  };

  const logout = () => {
    toast.success("You have been logged out successfully.")

    Cookies.remove("token");
    Cookies.remove("user");
    setIsAuthenticated(false);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, login, logout, user,loading }}>
      {children}
    </AuthContext.Provider>
  );
};

// Custom hook for easy usage
export const useAuth = () => useContext(AuthContext);
